import axios from 'axios';
import { BaseApiService } from '@/services/backend/base';

export class PersonalCommercialAPIService extends BaseApiService {
    constructor() {
        super('personal/commercial');
    }

    async getNoticesList(filters) {
        try {
            const response = await axios.get(this.getUrl('notices'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposalsList(filters) {
        try {
            const response = await axios.get(this.getUrl('proposals'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposal(id) {
        try {
            const response = await axios.get(this.getUrl(`proposals/${id}`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getContractsList(filters) {
        try {
            const response = await axios.get(this.getUrl('contracts/list'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    getContractsXlsExport(filters) {
        return axios.post(this.getUrl('contracts/xls'), filters, { responseType: 'blob' });
    }
}
